import {RegistrationService} from './../../services/impl/registration.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {MatDialog} from '@angular/material';
import {WizardService} from '../../services/wizard.service';
import {ActivatedRoute} from '@angular/router';
import {StepConfig} from '../../configuration/step-config';
import {CalculationService} from '../../services/impl/calculation.service';
import {ScrollHelper} from '../../../shared/services/scroll-helper';
import {NotificationService} from '../../services/impl/notification.service';
import {NotificationStorageService} from '../../../shared/services/notification-storage.service';
import {ConfigurationService} from '../../services/impl/configuration/configuration.service';
import {
  env,
  fillFormEvent,
  isCarOne,
  isEmbeddedInIframe,
  isKIOSKPOLIS,
  isMobile,
  isMPay,
  isNestBank,
  isNext,
  isOLX,
  isSkycash,
  isYANOSIK,
  logoUrl,
  salesChannel
} from '../../utils/utils';
import {ApplicationStateService} from '../../../shared/services/application-state.service';
import {AppMode} from '../../../shared/models/app-mode.enum';
import {SectionComponent} from '../../../shared/components/section/section.component';
import {StepKey} from '../../enums/step-key.enum';
import {OfferNumberContext, OfferNumberService} from '../../../shared/services/offer-number.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {MetricsService} from '../../../shared/services/metrics.service';
import {CustomMetricsName} from '../../../shared/components/models/metrics/custom-metrics-name.enum';
import {MetricsType} from '../../../shared/components/models/metrics/metrics-type.enum';
import {EnvironmentConsts} from '../../models/environment.consts';
import {formsDataMock} from '../../../shared/mocks/forms-data-mock';
import {DeviceService} from '../../../shared/services/device.service';
import {IframeCommunicationService} from '../../../shared/services/iframe-communication.service';
import {UrlParamsService} from '../../services/impl/url-params.service';
import {FiltersService} from '../../../shared/services/filters.service';
import {BannerConfig} from '../../configuration/ui-config';
import {OcDamagesDataService} from '../../../shared/services/oc-damages-data.service';
import {AssetsService} from '../../../shared/services/assets.service';
import {OfferModificationsService} from '../../services/impl/offer-modifications/offer-modifications.service';
import {
  AztecScannerDialogComponent
} from '../../../shared/components/dialogs/aztec-scanner-dialog/aztec-scanner-dialog.component';
import {ApplicationEventsService} from '../../../shared/services/application-events.service';
import {CalculationCacheService} from '../../services/impl/calculation-cache.service';
import {ProcessService} from '../../services/process.service';
import {BannersService} from '../../../shared/services/banners.service';
import {SalesChannel} from '../../consts/sales-channel.enum';
import {OfferSummaryAction} from '../../../shared/components/offer-summary/offer-summary.component';
import {SendCalculationEmailService} from '../../services/impl/send-calculation-email.service';
import {Ga4EventsConfigService} from '../../services/ga4-events-config.service';
import {QueryParamName} from '../../enums/query-param-name.enum';
import {LazyLoadingScriptsService} from '../../../shared/services/lazy-loading-scripts.service';
import {ScriptKey} from '../../enums/script-key.enum';
import {TestingPresetsService} from '../../../shared/services/debugging/testing-presets.service';
import {TestingPresetKey} from '../../enums/debugging/testing-preset-key.enum';

declare const eruda: any;

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit, AfterViewInit {

  @ViewChild('aboveButtonSectionsContainer', {read: ViewContainerRef}) aboveButtonSectionsContainer;
  @ViewChild('belowButtonSectionsContainer', {read: ViewContainerRef}) belowButtonSectionsContainer;

  debugMode = false;
  stepKey = StepKey;
  isNext = isNext();
  isKIOSKPOLIS = isKIOSKPOLIS();
  isCarOne: boolean = isCarOne();

  public printData: any;

  private scrollHelper: ScrollHelper = new ScrollHelper();
  private readonly offerNumberContext = OfferNumberContext.HEADER;
  private calculations = formsDataMock;
  private selectedCalculation;

  constructor(public calculationService: CalculationService,
              public wizardService: WizardService,
              public processService: ProcessService,
              public sendCalculationEmailService: SendCalculationEmailService,
              private bannersService: BannersService,
              private registrationService: RegistrationService,
              private offerNumberService: OfferNumberService,
              private filtersService: FiltersService,
              private configuration: ConfigurationService,
              private _route: ActivatedRoute,
              private dialog: MatDialog,
              private eventsService: ApplicationEventsService,
              private assetsService: AssetsService,
              private deviceService: DeviceService,
              public stateService: ApplicationStateService,
              private changeDetector: ChangeDetectorRef,
              private metricsService: MetricsService,
              public urlParamsService: UrlParamsService,
              private iframeService: IframeCommunicationService,
              private _notificationService: NotificationService,
              private ocDamagesDataService: OcDamagesDataService,
              private calculationCacheService: CalculationCacheService,
              public offerModificationsService: OfferModificationsService,
              private ga4EventsConfigService: Ga4EventsConfigService,
              private _notificationStorageService: NotificationStorageService,
              private lazyLoadingScriptsService: LazyLoadingScriptsService) {
  }

  get currentStep(): StepConfig {
    return this.wizardService.currentStep;
  }

  get nextButtonCaption(): string {
    return this.wizardService.nextButtonCaption;
  }

  get errorsOnStep(): boolean {
    return this.wizardService.errorsOnStep;
  }

  get appMode(): AppMode {
    return this.stateService.mode;
  }

  get loading(): boolean {
    return this.appMode === AppMode.NOTIFICATIONS;
  }

  get loadingWithoutSpinner(): boolean {
    return this.appMode === AppMode.WAITING_FOR_OFFER_LOADING;
  }

  get readonly(): boolean {
    return this.wizardService.readonly;
  }

  get mainContentHidden(): boolean {
    return this.loading || this.loadingWithoutSpinner;
  }

  get displayStepButton(): boolean {
    return this.wizardService.displayStepButton && this.wizardService.stepButtonVisible;
  }

  set displayStepButton(visibility: boolean) {
    this.wizardService.displayStepButton = visibility;
  }

  get nextButtonVisible(): boolean {
    let visible = !this.currentStep.isOfferStep;
    return this.displayStepButton && visible;
  }

  get nextButtonDisabled(): boolean {
    return this.wizardService.nextButtonDisabled;
  }

  get isInitStep(): boolean {
    return this.currentStep ? this.currentStep.stepKey === StepKey.FIRST_STEP_0 : false;
  }

  get isSecondStep(): boolean {
    return this.currentStep ? this.currentStep.stepKey === StepKey.SECOND_STEP : false;
  }

  get isThirdStep(): boolean {
    return this.currentStep ? this.currentStep.stepKey === StepKey.THIRD_STEP : false;
  }

  get isStepAutofillable(): boolean {
    return this.wizardService.isOcDetailsStep || this.isThirdStep;
  }

  get visibleMainImage(): boolean {
    return isKIOSKPOLIS() || isOLX() || isMPay() || isSkycash() || (isYANOSIK() && !this.isMobile) || isNestBank();
  }

  get isBankier(): boolean {
    return salesChannel() === SalesChannel.BANKIER;
  }

  get shortenedVehicleInfoVisible(): boolean {
    return this.isSecondStep && !this.isMobile && this.visibleAnyBanner;
  }

  get customerClaimDataVisible(): boolean {
    return this.shortenedVehicleInfoVisible && this.urlParamsService.isLoggedUserIdParam && this.ocDamagesDataService.atLeastOneValidMTUOffer;
  }

  get noBannerCustomerClaimDataVisible(): boolean {
    return isNotNullOrUndefined(this.mainContentHeader) && this.wizardService.resolveElementVisibility(this.mainContentHeader.customerDamageData) && this.isSecondStep && !this.isMobile && this.urlParamsService.isLoggedUserIdParam && this.ocDamagesDataService.atLeastOneValidMTUOffer;
  }

  get canShowGA4EventsDebugInfo(): boolean {
    return this.debugMode && env() !== EnvironmentConsts.PROD;
  }

  get canShowMockComponent(): boolean {
    return this.isStepAutofillable && this.debugMode && env() !== EnvironmentConsts.PROD;
  }

  get isMobile(): boolean {
    return isMobile();
  }

  get logo() {
    return this.headerConfig.logo;
  }

  get mainContentHeader() {
    return this.mainContentConfig.header;
  }

  get title() {
    return this.headerConfig.title;
  }

  get offerNumber() {
    return this.headerConfig.offerNumber;
  }

  get stepInfo() {
    return this.mainContentConfig.stepInfo;
  }

  get isLoggedUserIdParam(): boolean {
    return this.urlParamsService.isLoggedUserIdParam || this.stateService.isLoggedUserIdBusinessParam;
  }

  get ocDetailsStep(): boolean {
    return this.wizardService.isOcDetailsStep;
  }

  get offersStep(): boolean {
    return this.wizardService.isOffersStep;
  }

  get orderPolicyStep(): boolean {
    return this.wizardService.isOrderPolicyStep;
  }

  get showStepCounter(): boolean {
    return this.wizardService.resolveElementVisibility(this.stepInfo.stepCounter) && this.wizardService.isOcDetailsStep;
  }

  get showNavigateBackButton(): boolean {
    return this.wizardService.resolveElementVisibility(this.mainContentConfig.backButton) && (this.currentStep.stepKey === StepKey.FIRST_STEP_1 || this.currentStep.stepKey === StepKey.FIRST_STEP_2 || this.currentStep.stepKey === StepKey.FIRST_STEP_3);
  }

  get showNavigateBackButtonText(): boolean {
    return !this.isMobile && this.showNavigateBackButton;
  }

  get showNavigateBackButtonIcon(): boolean {
    return this.isMobile && this.showNavigateBackButton;
  }

  get headerConfig() {
    return this.configuration.uiConfig.headerConfig;
  }

  get mainContentConfig() {
    return this.configuration.uiConfig.mainContentConfig;
  }

  get mainImage() {
    return this.configuration.uiConfig.mainContentConfig.image;
  }

  get logoUrl(): string {
    return logoUrl();
  }

  get bannerStepConfig(): any {
    if (this.configuration.uiConfig.bannersConfig && this.currentStep) {
      return this.configuration.uiConfig.bannersConfig[this.currentStep.stepKey]
    }
    return null;
  }

  get bannerConfigOption(): BannerConfig {
    if (isNotNullOrUndefined(this.bannerStepConfig)) {
      return this.isMobile ? this.bannerStepConfig.mobile : this.bannerStepConfig.web;
    }
    return null;
  }

  get visibleAnyBanner(): boolean {
    return this.htmlBannerVisible || this.visibleImageBanner;
  }

  get htmlBannerVisible(): boolean {
    return this.bannersService.htmlBannersEnabled && !this.calculationCacheService.calculationSectionVisible(this.stateService.sessionId);
  }

  get visibleImageBanner(): boolean {
    if (this.htmlBannerVisible || isKIOSKPOLIS() || isNestBank()) {
      return false;
    }
    return this.bannerConfigOption ? this.bannerConfigOption.visible && !this.calculationCacheService.calculationSectionVisible(this.stateService.sessionId) : false;
  }

  get bannerUrl(): string {
    return this.bannerConfigOption.bannerPath;
  }

  get hasSectionsUnderStepButton(): boolean {
    return this.currentStep.sectionsUnderStepButton && !!this.currentStep.sectionsUnderStepButton.length;
  }

  get isMobileDevice(): boolean {
    return this.deviceService.isMobileDevice;
  }

  // method used because bottom placed calendars need more space
  get mainContainerBottomPadding(): boolean {
    return !this.isMobileDevice && isNotNullOrUndefined(this.currentStep) &&
      (this.currentStep.stepKey === StepKey.FIRST_STEP_2 ||
        (this.currentStep.stepKey === StepKey.FIRST_STEP_1 && !this.hasSectionsUnderStepButton)
      );
  }

  get filterVisibleAndExpanded(): boolean {
    return this.filtersService.filtersVisible && isNotNullOrUndefined(this.currentStep) && this.currentStep.isOfferStep && this.filtersService.filtersExpanded;
  }

  get fullWidthMainContainer(): boolean {
    if (this.isNext) {
      return (isNotNullOrUndefined(this.currentStep) && this.currentStep.isOfferStep) || this.wizardService.isNotificationStep;
    }
    return this.wizardService.isNotificationStep;
  }

  get isMPay(): boolean {
    return isMPay();
  }

  get isSkycash(): boolean {
    return isSkycash();
  }

  get narrowButton(): boolean {
    return (isSkycash() || isMPay()) && this.urlParamsService.isMobileOrigin && this.isThirdStep;
  }

  get offerPayEventPayload(): string {
    return JSON.stringify(this.offerPayEventDebugInfo.payload, null, 2);
  }

  get offerPayEventDebugInfo(): any {
    return this.eventsService.offerPayEventDebugInfo;
  }

  get showOfferPayEventDebugInfo(): boolean {
    return false;
    // return env() !== EnvironmentConsts.PROD && isMPay() && this.isOriginMobile && isNotNullOrUndefined(this.offerPayEventDebugInfo);
  }

  get offerSummaryStatic(): boolean {
    return this.isBankier || this.wizardService.stepBottomVisible;
  }

  get offerSummaryFixed(): boolean {
    return !this.wizardService.stepBottomVisible && !this.isBankier;
  }

  get aztecScannerInfoVisible(): boolean {
    return isKIOSKPOLIS() && !isMobile();
  }
  
  get narrowHeaderVisible(): boolean {
    return !this.isNext && !!this.wizardService.resolveElementVisibility(this.headerConfig);
  }
  
  get headerVisible(): boolean {
    return this.isNext && !!this.wizardService.resolveElementVisibility(this.headerConfig);
  }

  get vehicleDataVisible(): boolean {
    return this.isNext ? false : this.isSecondStep && this.isMobile;
  }

  get offerSummaryButtonDisabled(): boolean {
    return this.wizardService.isThirdStep ? !this.wizardService.isCurrentStepValidRealTime : false;
  }

  get scanAztecButtonWrapperVisible(): boolean {
    return false;
    // return this.isInitStep && this.aztecScannerInfoVisible;
  }

  get scanAztecButtonVisible(): boolean {
    return this.scanAztecButtonWrapperVisible && !this.wizardService.aztecScannedFromQrCode;
  }

  get stickyBanner(): boolean {
    return !isMobile() && !isNestBank();
  }

  get nextButtonIconVisible(): boolean {
    if (this.orderPolicyStep) {
      return false;
    }
    return isCarOne();
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (!this.debugMode) {
      this.debugMode = event.getModifierState && event.getModifierState('Control') && event.keyCode === 35;
    }
  }

  ngOnInit() {
    this.enableMobileConsole();
    this.ga4EventsConfigService.init();
    this.wizardService.init(this.aboveButtonSectionsContainer, this.belowButtonSectionsContainer, this._route);

    if (this._notificationStorageService.isNotification()) {
      this.displayStepButton = false;
    }

    this._notificationService.notificationSubject.asObservable().subscribe(() => {
      this.displayStepButton = false;
    });

    this.handleMobileOrigin();
    this.handleIframe();
  }

  ngAfterViewInit(): void {
    this.displayStepButton = true;
    this.changeDetector.detectChanges();
  }

  async next() {
    this.sendButtonMetric();
    let success: boolean = await this.wizardService.goNext();
    if (success) {
      this.iframeService.onStepChange();
      // this.scrollHelper.scrollToTop();
    } else {
      const timeoutTime = SectionComponent.totalCollapsedSections > 0 ? 300 : 0;
      this.scrollHelper.scrollTo('mat-error', timeoutTime);
    }
  }

  navigateBack(): void {
    window.history.back();
    setTimeout(() => this.scrollHelper.scrollToTop(), 1);
  }

  fillStep() {
    if (this.selectedCalculation) {
      fillFormEvent.emit({
        stepKey: this.wizardService.currentStep.stepKey,
        mock: this.selectedCalculation
      });
    }

    this.scrollHelper.scrollIntoView('.wizard__next-btn .btn', {block: 'center'});
  }

  printCalculationData() {
    this.printData = this.calculationService.calculationData;
  }

  printRegistrationData() {
    this.printData = this.registrationService.registration;
  }

  printBusinessParamsData() {
    this.printData = this.stateService.getAllBusinessParameters();
  }

  clearPrintData() {
    this.printData = null;
  }

  onOfferSummaryAction(action: OfferSummaryAction): void {
    switch (action) {
      case OfferSummaryAction.PAY:
        this.next();
        return;
      case OfferSummaryAction.RECALCULATE_PREMIUM:
        this.offerModificationsService.recalculatePremium();
        return;
      case OfferSummaryAction.BUY_ONLINE:
        this.wizardService.confirmOfferSelectedFromTable();
        return;
    }
  }

  private sendButtonMetric(): void {
    this.metricsService.sendSimpleMetric(CustomMetricsName.NEXT_STEP_BUTTON, MetricsType.BUTTON, this.currentStep.stepKey);
  }

  private handleMobileOrigin(): void {
    if (this.urlParamsService.isMobileOrigin) {
      document.querySelector('body').classList.add('body--origin-mobile');
      const activeQueryParams = this.urlParamsService.activeQueryParams;
      const openAztecScanner = activeQueryParams.hasOwnProperty(QueryParamName.OPEN_AZTEC_SCANNER) ? activeQueryParams[QueryParamName.OPEN_AZTEC_SCANNER] : null;
      if ((isMPay() || isSkycash()) && openAztecScanner === 'true') {
        this.dialog.open(AztecScannerDialogComponent, {
          data: {
            skipFirstStep: true
          }
        });
      }
    }
  }

  private handleIframe(): void {
    if (isEmbeddedInIframe()) {
      document.querySelector('body').classList.add('body--embedded-in-iframe');
    }
  }

  private enableMobileConsole(): void {
    if (TestingPresetsService.isPresetActive(TestingPresetKey.MOBILE_CONSOLE_ENABLED)) {
      this.lazyLoadingScriptsService.loadScript(ScriptKey.ERUDA_CONSOLE);
      const subscription = this.lazyLoadingScriptsService.getLoaded(ScriptKey.ERUDA_CONSOLE).subscribe(loaded => {
        if (loaded) {
          subscription.unsubscribe();
          eruda.init();
        }
      });
    }
  }
}
